import { useQuery } from '@tanstack/react-query';

import { useAccessToken } from '@sbv-clients/ui-shared';

import {
  ComplianceApiComplianceCalculateHppdGetRequest,
  ComplianceApiComplianceCalculateMinutesInShiftGetRequest,
  ComplianceCacheKeys,
  GetHppdRequest,
  useApi,
} from '..';

export const useHppdCensusGet = (getHppdRequest: GetHppdRequest) => {
  const { isMultiFacility } = useAccessToken();
  const api = useApi();
  return useQuery({
    queryKey: [ComplianceCacheKeys.HppdCensus, getHppdRequest],
    queryFn: () =>
      api.complianceApi
        .complianceHppdPost({ getHppdRequest })
        .then((response) => response.data.data ?? []),
    retry: false,
    refetchOnWindowFocus: false,
    enabled:
      ((isMultiFacility && Boolean(getHppdRequest.facilityId)) ||
        !isMultiFacility) &&
      Boolean(getHppdRequest.departmentId) &&
      Boolean(getHppdRequest.startDateTime) &&
      Boolean(getHppdRequest.endDateTime),
  });
};

export const useBudgetMinutes = (
  body: ComplianceApiComplianceCalculateMinutesInShiftGetRequest
) => {
  const api = useApi();
  return useQuery({
    queryKey: ['budget-minutes', body],
    queryFn: () =>
      api.complianceApi
        .complianceCalculateMinutesInShiftGet(body)
        .then((response) => response?.data?.data ?? {}),
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(body.startTime) && Boolean(body.endTime),
  });
};

export const useCalculateHppdGet = (
  body: ComplianceApiComplianceCalculateHppdGetRequest
) => {
  const api = useApi();
  return useQuery({
    queryKey: ['calculate-hppd', body],
    queryFn: () =>
      api.complianceApi
        .complianceCalculateHppdGet(body)
        .then((response) => response?.data?.data ?? {}),
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled:
      Boolean(body.startTime) && Boolean(body.endTime) && Boolean(body.unitId),
  });
};

export type CalculatedHPPDResponseType = NonNullable<
  ReturnType<typeof useCalculateHppdGet>['data']
>;
